import { checkPermissions, useAuth } from "@elit-hair/elit-tools";
import { createFileRoute } from "@tanstack/react-router";
import { useLocation } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { RecordDetails } from "@/components/record-details";
import { DASHBOARD_VARIANTS } from "@/constants/dashboard-variants";
import { PERMISSIONS } from "@/constants/permissions";
import { useRecordDetailsPanel } from "@/pages/home/components/RecordDetailsPanelContext";
import { useSettings } from "@/providers/general/settings-provider";
import { useCall } from "@/providers/hooks/use-call";
import { APP_ROUTES_FULL } from "@/utils/routes";

import { AgentPerformanceDashboard } from "./home/components/agent-performance-dashboard";
import { Dashboard } from "./home/components/dashboard";

export const Route = createFileRoute(APP_ROUTES_FULL.ROOT)({
    component: Home,
    staticData: {
        config: {
            title: "home",
        },
    },
});

function Home() {
    const { userData } = useAuth();
    const { currentSettings } = useSettings();
    const { isCallActive, currentCallData } = useCall();
    const [isRecordDetailsVisible, setIsRecordDetailsVisible] = useState(false);
    const location = useLocation();

    const canViewAgentPerformanceDashboard = checkPermissions(userData?.permissionCodes ?? [], [
        PERMISSIONS.CALL_DASHBOARD_AGENT_PERFORMANCE,
    ]);
    const selectedDashboard = currentSettings.SELECTED_DASHBOARD ?? DASHBOARD_VARIANTS.WIDGETS;
    const showAgentPerformanceDashboard =
        selectedDashboard === DASHBOARD_VARIANTS.AGENT_PERFORMANCE && canViewAgentPerformanceDashboard;

    const recordPanel = useRecordDetailsPanel();

    const callIsActive = isCallActive();

    useEffect(() => {
        if (callIsActive) {
            setIsRecordDetailsVisible(true);
        } else {
            setIsRecordDetailsVisible(false);
        }
    }, [callIsActive]);

    useEffect(() => {
        const state = location.state as { showRecordDetails?: boolean; showCallDetails?: boolean };
        if ((state?.showRecordDetails || state?.showCallDetails) && callIsActive) {
            setIsRecordDetailsVisible(true);
        }
    }, [location.state, callIsActive]);

    if (!recordPanel) return null;
    const { show, recordId, moduleType } = recordPanel;

    return (
        <>
            {(show && recordId) || (callIsActive && isRecordDetailsVisible) ? (
                <RecordDetails
                    recordId={
                        callIsActive && isRecordDetailsVisible ? currentCallData?.recordId : (recordId ?? undefined)
                    }
                    moduleType={callIsActive && isRecordDetailsVisible ? currentCallData?.moduleType : moduleType}
                />
            ) : showAgentPerformanceDashboard ? (
                <AgentPerformanceDashboard />
            ) : (
                <Dashboard />
            )}
        </>
    );
}
